import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { TraderInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class TraderApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(): Observable<Transaction<TraderInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getTraders());
    }

    loadExternal(): Observable<Transaction<TraderInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getExternalTraders());
    }
}
